/**
 * An eight-pointed star lattice — the khatim, two squares at forty-five
 * degrees to each other, tessellated.
 *
 * Geometry rather than imagery, which is the tradition's own answer to
 * ornament: it carries the character of the place without depicting anything.
 * Drawn as an SVG pattern rather than shipped as a bitmap so it stays crisp at
 * any size, costs nothing to download, and takes its colour from the text
 * colour of wherever it is placed.
 *
 * Decorative only, so it is hidden from assistive technology.
 */
export function IslamicPattern({
  className,
}: {
  className?: string | undefined;
}) {
  return (
    <svg className={className} aria-hidden="true" focusable="false">
      <defs>
        <pattern
          id="khatim"
          width="56"
          height="56"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(0)"
        >
          {/* The star: a square and the same square turned 45°. */}
          <rect
            x="14"
            y="14"
            width="28"
            height="28"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
          <rect
            x="14"
            y="14"
            width="28"
            height="28"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            transform="rotate(45 28 28)"
          />
          {/* The lattice that carries one star into the next. */}
          <circle
            cx="28"
            cy="28"
            r="3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
          <path
            d="M0 0 L56 56 M56 0 L0 56"
            stroke="currentColor"
            strokeWidth="0.5"
            opacity="0.5"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#khatim)" />
    </svg>
  );
}
